var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenlink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.072 0H8.915a.925.925 0 0 0 0 1.849h2.925L6.961 6.727a.918.918 0 0 0-.27.654c0 .247.095.48.27.654a.918.918 0 0 0 .654.27.918.918 0 0 0 .653-.27l4.88-4.88v2.926a.925.925 0 0 0 1.848 0V.924A.925.925 0 0 0 14.072 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.623 13.411H1.585V4.372h6.798l1.584-1.584H.792A.792.792 0 0 0 0 3.58v10.624c0 .437.355.792.792.792h10.624a.792.792 0 0 0 .792-.792V5.029l-1.585 1.584v6.798z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenlink);
export default __webpack_public_path__ + "static/media/openlink.77aee69882ec7c28b729be733f371a4a.svg";
export { ForwardRef as ReactComponent };